export function scrollTo(element) {
  // Padding of 15px
  const navbarHeight
        = document.querySelector('.navbar__desktop').offsetHeight + 15
  window.scroll(0, element.offsetTop - navbarHeight)
}
